__turbopack_context__.v({
  "circle": "EnablingCircles-module__EMxm6G__circle",
  "circleActive": "EnablingCircles-module__EMxm6G__circleActive",
  "circleContent": "EnablingCircles-module__EMxm6G__circleContent",
  "circleLabel": "EnablingCircles-module__EMxm6G__circleLabel",
  "circleMagnifier": "EnablingCircles-module__EMxm6G__circleMagnifier",
  "circleScrim": "EnablingCircles-module__EMxm6G__circleScrim",
  "circleTexture": "EnablingCircles-module__EMxm6G__circleTexture",
  "row": "EnablingCircles-module__EMxm6G__row",
  "rowEnd": "EnablingCircles-module__EMxm6G__rowEnd",
  "scroller": "EnablingCircles-module__EMxm6G__scroller",
});
